import React from 'react'
import { ModalProps } from '../../types'
import { ionHistory } from '../../../navigation'

import classNames from 'classnames'
import ModalShell from './ModalShell'
import './styles.less'
import { getDirMode } from 'mobile_web/modules/platform'

const Modal: React.FC<ModalProps> = props => {
	const navigateWithNewState = (modalOpen: boolean) => {
		const historyState = {}
		Object.assign(historyState, ionHistory.location.state)
		const url = ionHistory.location.pathname + ionHistory.location.search + ionHistory.location.hash

		ionHistory.replace(url, { ...historyState, modalOpen })
	}

	return (
		<ModalShell
			isOpen={props.isOpen}
			backdropDismiss={props.backdropDismiss}
			showBackdrop={props.showBackdrop}
			data-cy={props['data-cy']}
			onDidPresent={() => {
				if (props.onDidPresent) {
					props.onDidPresent()
				}
				if (!props.preventNavigate) {
					navigateWithNewState(true)
				}
			}}
			onDidDismiss={() => {
				if (props.onDidDismiss) {
					props.onDidDismiss()
				}
				if (!props.preventNavigate) {
					navigateWithNewState(false)
				}
			}}
			className={classNames('app-modal', props.cssClass, `container-${getDirMode()}`)}
		>
			{props.children}
		</ModalShell>
	)
}

export default Modal
